<template>
  <!-- 提成比例设置 -->
  <el-dialog
    :visible.sync="CommissionPercentage"
    width="25%"
    :title="title"
    class="addBrand"
    @close="onClose"
  >
    <el-form
      :model="queryParams"
      ref="queryParamsRefs"
      :rules="queryParamsRules"
      label-width="80px"
      class="demo-ruleForm"
    >
      <el-form-item label="提成比例：" prop="account" label-width="100px">
        <div style="display: flex">
          <el-input-number :controls="false" v-model="queryParams.account"></el-input-number>
<!--          <el-input v-model="queryParams.account" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>-->
          <span style="margin-left: 10px;">%</span>
        </div>
      </el-form-item>
      <!-- <el-form-item>

      </el-form-item>-->
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSubmit('queryParams')">确 定</el-button>
      <el-button @click="onClose">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { AddCommissInfo, UpdateComminsIfo } from '@/api/system/rightsManagement'
import { isSuccess } from '@/util/tool'
import NP from 'number-precision'

export default {
  data () {
    var chackCommis = (rule, value, callback) => {
      if (!value) {
        callback(new Error('保存失败，必填项不可为空!'))
      } else if (value / 100 > 1) {
        callback(new Error('保存失败，提成不可大于100%!'))
      } else if (value / 100 <= 0) {
        callback(new Error('保存失败，提成比例不可小于等于0%!'))
      } else {
        callback()
      }
    }
    return {
      hashtablelist: [], // 去除重复以后的数据
      CommissionPercentage: false,
      // 添加物流信息
      queryParams: {
        account: '' // 账号
      },
      type: 0,
      title: '',
      queryParamsRules: {
        account: [{ required: true, validator: chackCommis, trigger: 'blur' }]
      },
      CommisValues: {},
      isfrom: 0
    }
  },
  // props:['CommisValues'],
  methods: {
    // 提成比例设置
    onInitialize (type, from) {
      // type=1提成比例设置,type=2为配置账户
      this.queryParams = {
        account: '', // 账号
        password: '' // 密码
      }
      // this.queryParamsRules = addOrEditBrandRules// 初始化校验
      this.type = type
      this.title = '提成比例设置'
      // this.CommissionPercentage = true
      if (from === 1) {
        this.queryParams.account = ''
        this.isfrom = 1
      } else {
        this.isfrom = 2
        const commis = `${this.CommisValues.commission}`.split('%')
        // debugger
        this.queryParams.account = commis[0]
      }
    },
    // 确定
    onSubmit () {
      this.$refs.queryParamsRefs.validate(valid => {
        if (valid) {
          const parmas = {
            commission: NP.strip(this.queryParams.account / 100),
            createDate: '',
            createIp: 0,
            createUser: '',
            flag: true,
            id: 0,
            serial: 0
          }
          if (Number(this.isfrom) === 1) {
            // alert('1')
            AddCommissInfo(parmas).then(res => {
              if (isSuccess(res)) {
                this.$message({
                  message: res.data.msg,
                  type: 'success'
                })
                this.CommissionPercentage = false
              } else {
                this.$message.error(res.data.msg)
              }
              this.$parent.getInitTable()
            })
          } else {
            this.$set(
              this.CommisValues,
              'commission',
              this.queryParams.account / 100
            )
            const updateparmas = {
              createDate: this.CommisValues.createDate,
              createIp: this.CommisValues.createIp,
              createUser: this.CommisValues.createUser,
              flag: this.CommisValues.flag,
              id: this.CommisValues.id,
              serial: this.CommisValues.serial,
              commission: this.queryParams.account / 100
            }
            UpdateComminsIfo(updateparmas).then(res => {
              if (isSuccess(res)) {
                this.$message({
                  message: res.data.msg,
                  type: 'success'
                })
                this.CommissionPercentage = false
              } else {
                this.$message.error(res.data.msg)
              }
              this.$parent.getInitTable()
            })
          }
        } else {
          // this.$message.error('校验未通过')
          return false
        }
      })
    },
    // 取消关闭弹窗
    onClose () {
      this.$refs.queryParamsRefs.clearValidate() // 去掉校验
      this.CommissionPercentage = false
    }
  }
}
</script>

<style lang="scss" scoped>
.demo-ruleForm {
  width: 100%;
  display: flex;
  align-items: center;
}
.demo-ruleForm .commission-tag {
  width: 90%;
  margin-bottom: 5px;
}
</style>
